<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.6)" size="medium" color="#6f3118" type="square-jelly-box" [fullScreen]="true"></ngx-spinner>